// src/HomePage/Game/FolkGame/FolkGame.js
import React, { useState } from 'react';
import CaroIndex from './Caro/CaroIndex';
import OAnQuanIndex from './OAnQuan/OAnQuanIndex';
import './FolkGame.css';

const FolkGame = ({ user, isCatechist, studentId }) => {
  const [selectedGame, setSelectedGame] = useState(null);

  const currentUser = user ? {
    id: isCatechist ? localStorage.getItem('uid') : (studentId || localStorage.getItem('studentId')),
    fullName: user.fullName || localStorage.getItem('studentFullName') || 'Người chơi',
    holyName: user.holyName || localStorage.getItem('studentHolyName') || '',
    isCatechist: Boolean(isCatechist)
  } : null;

  // Điều hướng đến trò chơi được chọn
  if (selectedGame === 'caro') {
    return (
      <CaroIndex
        currentUser={currentUser}
        onBackToPortal={() => setSelectedGame(null)}
      />
    );
  }

  if (selectedGame === 'oanquan') {
    return (
      <OAnQuanIndex
        currentUser={currentUser}
        onBackToPortal={() => setSelectedGame(null)}
      />
    );
  }

  return (
    <div className="folk-portal-wrapper">
      <div className="folk-portal-header">
        <h2>🎲 Sân Chơi Trò Chơi Dân Gian 🎲</h2>
        <p>Chọn trò chơi yêu thích để so tài cùng bạn bè hoặc luyện tập với máy</p>
      </div>

      <div className="folk-portal-grid">
        {/* Card 1: Cờ Caro */}
        <div
          className="folk-game-card active-playable"
          onClick={() => setSelectedGame('caro')}
        >
          <div className="folk-card-badge open">🟢 Đang mở</div>
          <div className="folk-card-icon">⭕❌</div>
          <div className="folk-card-details">
            <h3>Cờ Caro</h3>
            <p>Trí tuệ đỉnh cao với 5 ô thẳng hàng. Hỗ trợ đấu Online thời gian thực & luyện tập cùng Bot.</p>
          </div>
          <button className="folk-card-play-btn">
            Vào Bàn Chơi Ngay 🚀
          </button>
        </div>

        {/* Card 2: Cờ Ô Ăn Quan */}
        <div
          className="folk-game-card active-playable"
          onClick={() => setSelectedGame('oanquan')}
        >
          <div className="folk-card-badge open">🟢 Đang mở</div>
          <div className="folk-card-icon">🪨🌾</div>
          <div className="folk-card-details">
            <h3>Cờ Ô Ăn Quan</h3>
            <p>Chiến thuật rải sỏi tính điểm truyền thống. Hỗ trợ đấu Online & rèn luyện cùng AI Robot.</p>
          </div>
          <button
            className="folk-card-play-btn"
            style={{ background: 'linear-gradient(135deg, #f59e0b, #d97706)' }}
          >
            Vào Bàn Chơi Ngay 🚀
          </button>
        </div>
      </div>
    </div>
  );
};

export default FolkGame;